enum CommonFieldName {
  COLOR = "color",
  COMPANY = "account",
  COMPANY_IMPORT_ID = "account.importId",
  CREATED_AT = "createdAt",
  CREATOR = "creator",
  CREATOR_EMAIL = "creator.username",
  CREATOR_NAME = "creatorName",
  CRM_ACTIVITY_TYPE_ID = "crmActivityTypeId",
  CRM_LINK = "crmLink",
  DAYS_LEFT_IN_FREQUENCY = "daysLeftInFrequency",
  FILES = "files",
  FREQUENCY_INTERVAL = "cadenceInterval",
  FREQUENCY_STATUS = "cadenceDaysOut",
  GEOPOINT = "geoPoint",
  GROUPS = "groups",
  LAST_ACTIVITY_DATE = "lastCompletedActivity.completedAt",
  LAST_ACTIVITY_NAME = "lastCompletedActivity.name",
  LAST_ACTIVITY_TYPE = "lastCompletedActivity.activityType",
  NAME = "name",
  EMAIL = "email",
  NEXT_ACTIVITY = "upcomingActivity.startAt",
  NO_CONTACT_IN = "noContactDaysOut",
  NOTES = "notes",
  OWNER_EMAIL = "user.username",
  OWNER_NAME = "ownerName",
  PERSON = "contact",
  PERSON_IMPORT_ID = "contact.importId",
  SOURCE = "sourceCreated",
  SOURCE_OBJECT = "sourceObject",
  TEAM = "team",
  TERRITORIES = "territories",
  UNIQUE_ID = "importId",
  UPDATED_AT = "updatedAt",
  USER = "user",
  VIEW_AS = "viewAs",
}

export default CommonFieldName;
